/* eslint-disable no-unused-vars */
import TextField from "@mui/material/TextField";
import clsx from "clsx";
import { Formik } from "formik";
import queryString from "querystring";
import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { connect, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { getUserByToken, login } from "../../../crud/auth.crud";
import * as auth from "../../../store/ducks/auth.duck";
import Loading from "../../home/components/Loading";
// import ActivateAccount from "./ActivateAccount";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import { CustomEyeIcon } from "../../../../app/components/CustomIcons/CustomEye";
import { CustomEyeOffIcon } from "../../../../app/components/CustomIcons/CustomEyeOff";

import { makeStyles } from "@material-ui/core";
import { Typography } from "@mui/material";
import globalColors from "../../../../_metronic/_assets/sass/custom/globalColors.scss";
import verifyCpfCnpj from "../../../utils/validators/IsValidCpfCnpj";
import Swal from 'sweetalert2';
import { wasLoggoutByRefreshToken, removeLoggoutByRefreshToken } from "../../../utils/LocalStorage.js";

const useStyles = makeStyles({
  root: {
    "& label": {
      color: globalColors.textColor1,
    },
    "& label.Mui-focused": {
      color: globalColors.textColor1,
    },
    "& input": {
      color: globalColors.textColor1,
      padding: "12px 16px",
      fontSize: "14px",
      borderRadius: "8px",
    },
    "& .MuiOutlinedInput-root": {
      height: "100vh",
      maxHeight: "48px",
      "& fieldset": {
        borderColor: globalColors.textColor2,
      },
      "&.Mui-focused fieldset": {
        border: `1px solid ${globalColors.primaryColor2}`,
      },
    },
  },
  multilineColor: {
    color: globalColors.textColor1,
    fontSize: "14px",
    borderRadius: "8px",
  },
  typography: {
 fontFamily: "Open Sans",  fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "24px",
    borderRadius: "8px",
  },
  svg: {
    fill: globalColors.colorWhite,
    stroke: "#808080",
  }
});

function Login(props) {
  const { intl, history } = props;
  const classes = useStyles();

  const stored = window.localStorage.getItem(
    "remember:advocacia-xavier:rememberMe"
  );
  let data = null;
  try {
    data = stored ? JSON.parse(stored) : null;
  } catch (error) {
    window.localStorage.removeItem("remember:advocacia-xavier:rememberMe");
  }

  const getInitialFormData = () => {
    if (data && data.rememberMe && data.cpfCnpj) {
      return {
        cpfCnpj: data.cpfCnpj,
        password: "",
        rememberMe: true,
      };
    } else {
      return {
        cpfCnpj: "",
        password: "",
        rememberMe: false,
      };
    }
  };

  const [formData] = useState(getInitialFormData);
  // const [activateModal, setActivateModal] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loginError, setLoginError] = useState("");

  const [loadingButtonStyle, setLoadingButtonStyle] = useState({
    paddingRight: "2.5rem",
  });

  const user = useSelector((state) => state?.auth);

  useEffect(() => {
    validateLogoutByRefreshToken()

    if (!!user?.user) {
      history.replace({
        pathname: "/admin/processo",
      });
    }
  }, [user.user, history]);

  const enableLoading = () => {
    setIsLoading(true);
    setLoading(true);
    setLoadingButtonStyle({ paddingRight: "3.5rem" });
  };

  const disableLoading = () => {
    setLoading(false);
    setIsLoading(false);
    setLoadingButtonStyle({ paddingRight: "2.5rem" });
  };

  const isLoginExpired = () => {
    const query = queryString.parse(window.location.search.replace("?", ""));
    return query && query.hasOwnProperty("expired");
  };

  const getUserFromAccessToken = (accessToken) => {
    const payload = accessToken.split(".")[1];
    const normalizedPayload = payload.replace(/-/g, "+").replace(/_/g, "/");
    const paddedPayload = normalizedPayload.padEnd(
      normalizedPayload.length + ((4 - (normalizedPayload.length % 4)) % 4),
      "="
    );
    return JSON.parse(window.atob(paddedPayload));
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const validateLogoutByRefreshToken = () => {
      // Disconnected by refresh token

    if (wasLoggoutByRefreshToken()) {
      Swal.fire({
        customClass: {
          container: 'swal-logout',
        },
        title: 'Oops...',
        text: 'Sua sessão expirou! Por favor efetue o login novamente.',
        icon: 'warning',
      });
    }

    removeLoggoutByRefreshToken();
  }
  window.setPageTitle("Login");
  return (
    <>
      <Loading isLoading={isLoading} />
      <div className="kt-login__body">
          <div className="kt-login__form">
            <div
              className="kt-login__title"
              style={{
                margin: "0"
              }}
            >
              <Typography
                variant="h3"
                style={{
                  color: globalColors.primaryColor5,
                  fontSize: "24px",
                  fontWeight: "700",
                  margin: "0"
                }}
              >Faça seu login</Typography>
            </div>
            <Formik 
              initialValues={formData}
              validate={(values) => {
                const errors = {};

                if (!values.cpfCnpj) {
                  errors.cpfCnpj = intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                  });
                } else if (
                  !verifyCpfCnpj(values.cpfCnpj).isValid
                ) {
                  errors.cpfCnpj = intl.formatMessage({
                    id: "AUTH.VALIDATION.INVALID_FIELD",
                  });
                }

                if (!values.password) {
                  errors.password = intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                  });
                }

                return errors; 
              }}
              onSubmit={async (values, { setFieldTouched, setFieldValue, setStatus, setSubmitting }) => {
                setLoginError("");
                setStatus(undefined);
                enableLoading();
                try {
                  const auth = await login(values.cpfCnpj.replace(/[^0-9]/g,''), values.password, true);

                  if (auth) {
                    const currentAccessKey = "xavier-portal:current-access-at";
                    const previousAccessKey = "xavier-portal:previous-access-at";
                    const currentAccess = localStorage.getItem(currentAccessKey);
                    if (currentAccess) {
                      localStorage.setItem(previousAccessKey, currentAccess);
                    }
                    localStorage.setItem(currentAccessKey, new Date().toISOString());

                    auth.isLogin = true;
                    const authenticatedUser = getUserFromAccessToken(
                      auth.access_token
                    );
                    props.authenticated(auth, authenticatedUser);

                    localStorage.setItem(
                      "remember:advocacia-xavier:rememberMe",
                      JSON.stringify({
                        rememberMe: values.rememberMe,
                        cpfCnpj: values.cpfCnpj,
                      })
                    );

                    if (!values.rememberMe) {
                      console.log("teste entrou aqui");
                      localStorage.setItem(
                        "remember:advocacia-xavier:rememberMe",
                        JSON.stringify({
                          rememberMe: values.rememberMe,
                          login: "",
                        })
                      );
                    }

                    disableLoading();
                    history.replace("/admin/processo");

                    // Atualiza os dados em segundo plano sem bloquear a entrada.
                    getUserByToken()
                      .then(props.fulfillUser)
                      .catch(() => undefined);
                  } else {
                    throw new Error("CPF/CNPJ ou senha inválidos");
                  }
                } catch (e) {
                  disableLoading();
                  setSubmitting(false);
                  setFieldValue("password", "", false);
                  setFieldTouched("password", false, false);
                  setShowPassword(false);
                  const statusCode = e?.response?.status;
                  const message = !e?.response
                    ? "Não foi possível conectar ao portal. Verifique sua internet e tente novamente."
                    : statusCode === 409
                    ? "Seu acesso ainda não está ativo. Entre em contato com o escritório."
                    : statusCode === 401 || statusCode === 404
                    ? "CPF/CNPJ ou senha incorretos. Confira os dados e tente novamente."
                    : e?.response?.data?.message ||
                      intl.formatMessage({
                        id: "AUTH.VALIDATION.INVALID_LOGIN",
                      });
                  setLoginError(message);
                  setStatus(message);
                }
              }}
              style={{
                margin: "0"
              }}
            >
              {({
                values,
                status,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
              }) => (
                <div
                  style={{
                    margin: "0"
                  }}
                >
                  <form
                    noValidate={true}
                          autoComplete="username"
                    className="kt-form"
                    style={{
                      marginTop: "20px"
                    }}
                    onSubmit={handleSubmit}
                  >
                    {(loginError || status || isLoginExpired()) && (
                      <div
                        role="alert"
                        aria-live="assertive"
                        className="alert alert-danger xv-auth-login-error"
                      >
                        <div className="alert-text">
                          {loginError || status ||
                            "Sua sessão expirou, faça login para continuar"}
                        </div>
                      </div>
                    )}

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "28px",
                      }}
                    >
                      <div className="form-group">
                        <TextField
                          label="CPF/CNPJ"
                          name="cpfCnpj"
                          type="text"
                          sx={{
                            "& label": {
                              fontSize: "16px",
                              backgroundColor: "white",
                              paddingRight: "10px"
                            },
                          }}
                          placeholder="Digite CPF/CNPJ"
                          value={values.cpfCnpj} // Utilize values.email para definir o valor da input
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.cpfCnpj && !!errors.cpfCnpj}
                          helperText={touched.cpfCnpj && errors.cpfCnpj}
                          className={clsx(classes.root)}
                          fullWidth
                          margin="normal"
                          variant="outlined"
                          InputProps={{
                            classes: { input: classes.multilineColor },
                            style: {
                              borderRadius: "8px",
                            },
                          }}
                          InputLabelProps={{ shrink: true }}
                          autoComplete="username"
                        />

                      </div>

                      <div className="form-group">
                        <TextField 
                          type={showPassword ? "text" : "password"}
                          InputLabelProps={{ shrink: true }} 
                          label="Senha"
                          name="password"
                          className={`${classes.multilineColor} ${classes.typography} ${classes.root}`}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          placeholder="Digite sua senha"
                          value={values.password}
                          autoComplete="current-password"
                          helperText={touched.password && errors.password}
                          error={Boolean(touched.password && errors.password)}
                          fullWidth
                          inputProps={{
                            style: {
                              textTransform: "none"
                            }
                          }}
                          InputProps={{
                            style: {
                              borderRadius: "8px",
                            },
                            endAdornment: (
                              <InputAdornment
                                position="end"
                                sx={{ padding: 0 }}
                              >
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showPassword ? (
                                    <CustomEyeIcon />
                                  ) : (
                                    <CustomEyeOffIcon />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          sx={{
                            "& label": {
                              fontSize: "16px",
                              backgroundColor: "white",
                              paddingRight: "10px"
                            },
                          }}
                        />
                      </div>
                    </div>

                    <div className="kt-login__content">
                      <div className="kt-login__separator">
                        <label className="xv-auth-checkbox-control">
                          <input
                            checked={values.rememberMe}
                            id="rememberMe"
                            name="rememberMe"
                            onChange={(event) =>
                              setFieldValue("rememberMe", event.target.checked)
                            }
                            type="checkbox"
                          />
                          <span className="xv-auth-checkbox" aria-hidden="true" />
                          <span className="kt-remember-me">Lembrar-me</span>
                        </label>
                      </div>
                      <li
                        type="button"
                        onClick={() => history.push("/auth/recuperar-senha")}
                        className="justify-content-start forgot-password kt-remember-me kt-login__underline"
                      >
                        Esqueci minha senha
                      </li>
                    </div>
                    <div className="kt-login__actions mb-0 pb-0 ">
                      <button
                        id="kt_login_signin_submit"
                        type="submit"
                        disabled={isSubmitting}
                        className={"btn btn-elevate btn-width justify-content-end kt-login__btn-primary"}
                        style={{
                          backgroundColor: (errors.cpfCnpj || errors.cpfCnpj || !values.cpfCnpj || !values.password) ? globalColors.backgroundColor2 : globalColors.primaryColor1,
                          border: (errors.cpfCnpj || errors.password || !values.cpfCnpj || !values.password) ? globalColors.backgroundColor2 : globalColors.primaryColor1,
                          fontFamily: "Open Sans",
                          fontSize: "18px",
                          borderRadius: "8px",
                          textTransform: "none",
                        }}
                      >
                        <b>Entrar</b>
                      </button>
                    </div>
                  </form>
                </div>
              )}
            </Formik>
          </div>
        </div>
      {/* <ActivateAccount
        email={email}
        open={activateModal}
        setOpen={setActivateModal}
      /> */}
    </>
  );
}

const mapActionsToProps = (dispatch) =>
  bindActionCreators(
    {
      login: auth.actions.login,
      authenticated: auth.actions.authenticated,
      fulfillUser: auth.actions.fulfillUser,
    },
    dispatch
  );

export default injectIntl(connect(null, mapActionsToProps)(Login));
